module.exports = require("./../../_gen/starling/errors/AbstractClassError");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/errors/AbstractClassError.js
// module id = 175
// module chunks = 0